// No need for hardcoding, values are all in correct order
const numDesigns = 5;
const modern = [];

for ( let i = 0; i < numDesigns; i++ ) {
  const number = 100 + i;
  modern.push( {
    number: `HM${number}`
  });
}

export default modern;